import { Box, Grid, Container } from '@material-ui/core';
import React from 'react';
import FlightDealCard from '../../components/reusableComponents/FlightDealCard';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import TitleText from '../../components/reusableComponents/TitleText';
import BLR from '../../assets/images/BLR.jpg';
const list = [
	{
		image: BLR,
		title: 'Mumbai',
	},
	{
		image: BLR,
		title: 'Ranchi',
	},
	{
		image: BLR,
		title: 'Kolkata',
	},
	{
		image: BLR,
		title: 'Delhi',
	},
	{
		image: BLR,
		title: 'Goa',
	},
	{
		image: BLR,
		title: 'Pune',
	},
	{
		image: BLR,
		title: 'Bangalore',
	},
];
const FlightDeal = () => {
	return (
		<>
			<HeaderSection id={4} />
			<Box textAlign='center' mt={'120px'}>
				<TitleText textStyle={{ fontSize: 24, fontWeight: 500 }}>
					Special Deal from Origin Airports
				</TitleText>
			</Box>
			<Container style={{ marginTop: 20 }}>
				<Grid container spacing={4}>
					{list.map((item, index) => {
						return (
							<>
								<Grid item xs={12} sm={6} md={3} lg={3}>
									<FlightDealCard item={item} index={index} />
								</Grid>
							</>
						);
					})}
				</Grid>
			</Container>
		</>
	);
};

export default FlightDeal;
